'use strict';

import 'google';

import { simplifyGLL } from 'utils/douglas-peucker';

const MODULE_NAME = 'daupler.notify_beta';

var app = angular.module(MODULE_NAME, [
]);


const FEAT_TYPES = {
	FREEHAND: 'FREEHAND',
};


app.controller('NotifyBetaCtrl', ($http, $timeout) => {
	'ngInject';
	const vm = {
        map: null,
		features: [],
		sent: false,
	};

	vm.buildMap = function(id, config) {
		if (vm.map) return;
        vm.map = new google.maps.Map(document.getElementById(id), {
            // mapTypeId: 'satellite',
            mapTypeControl: false,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_RIGHT,
            },
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
                styles: [
                    {
                        featureType: "transit",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "poi",
                        stylers: [{ visibility: "off" }],
                    },
                ],
        });
		const bounds = new google.maps.LatLngBounds();
		bounds.extend({
			lat: config.service_area.lat_min,
			lng: config.service_area.lng_max,
		});
		bounds.extend({
			lat: config.service_area.lat_max,
			lng: config.service_area.lng_min,
		});
		vm.map.fitBounds(bounds);
		google.maps.event.addDomListener(vm.map.getDiv(), 'mousedown', () => {
			if (vm.readyForFreehand) {
				$timeout(() => {
					vm.startFreehand();
				}, 0);
			}
		});
	}

	vm.readyForFreehand = false;

	vm.prepareFreehand = function() {
		vm.readyForFreehand = true;
		vm.map.setOptions({
			draggable: false,
			draggableCursor: 'crosshair',
			zoomControl: false,
		});
	}

	vm.startFreehand = function() {
		if (!vm.map || !vm.readyForFreehand || vm._geometry) return;
		vm._geometry = new google.maps.Polyline({
			map: vm.map,
			clickable: false,
			strokeColor: '#AA2143',
			strokeWeight: 3,
		});
		const move = vm.map.addListener('mousemove', (e) => {
			vm._geometry.getPath().push(e.latLng);
		});
		google.maps.event.addListenerOnce(this.map, 'mouseup', (e) => {
			const simpPts = simplifyGLL(vm._geometry.getPath().getArray(), 0.0001);
			simpPts.push(simpPts[0]);

			addPolygonFeat(simpPts);

			vm._geometry.setMap(null);
			delete vm._geometry;

			google.maps.event.removeListener(move);

			vm.map.setOptions({
				draggableCursor: '',
				draggable: true,
				zoomControl: true,
			});

			$timeout(() => {
				vm.readyForFreehand = false;
			}, 0);
		});
	}

	vm.rf = function(i) {
		if (!i) i = vm.features.length - 1;
		const f = vm.features.splice(i, 1)[0];
		f.data.setMap(null);
		updateLocations();
	}

    vm.prepareFollowUp = function(notification) {
        _clearPaths();
        for (const pts of notification.paths) {
            const path = pts.map((p) => new google.maps.LatLng(p[1], p[0]));
            _addPathToMap(path);
        }
        updateLocations();
    }

    function _clearPaths() {
        for (const f of vm.features) {
            f.data.setMap(null);
        }
        vm.features = [];
    }

    function _addPathToMap(path) {
        const bounds = vm.map.getBounds();
        let boundsUpdated = false;
        for (const p of path) {
            if (!bounds.contains(p)) {
                boundsUpdated = true;
                bounds.extend(p);
            }
        }
        if (boundsUpdated) {
            vm.map.fitBounds(bounds);
        }
        const polygon = new google.maps.Polygon({
            map: vm.map,
            fillColor: '#AAA',
            fillOpacity: 0.2,
            strokeColor: '#AA2143',
            strokeWeight: 3,
            clickable: false,
            zIndex: 1,
            path: path,
            editable: false
        });
		vm.features.push({
			type: FEAT_TYPES.FREEHAND,
            data: polygon,
		});
    }

	function addPolygonFeat(path) {
        _addPathToMap(path);
		updateLocations();
	}

	function removeMarkers() {
		if (vm.markers) {
			for (const m of vm.markers) {
				m.setMap(null);
			}
		}
        if (vm.heatmap) {
            vm.heatmap.setMap(null);
            vm.heatmap = null;
        }
		vm.markers = [];
	}

	function updateLocations() {
        vm.updatingLocations = true;
		if (vm.features.length == 0) {
			vm.count = 0;
			removeMarkers();
			return;
		}
		$http.post('/api/flux/notify/v2/get_locations_by_paths/', {
			paths: vm.features.map((f) => {
				switch (f.type) {
					case FEAT_TYPES.FREEHAND:
						return f.data.getPath().getArray().map((p) => [p.lng(), p.lat()]);
					default:
						throw new Error(`Unexpected feature type ${f.type}`);
				}
			}),
		}).then((response) => {
			vm.count = response.data.count;
			if (response.data.points) {
				removeMarkers();
                const heatmapData = [];
                const includeMarkers = response.data.points.length < 100;
				for (const p of response.data.points) {
                    if (includeMarkers) {
                        vm.markers.push(
                            new google.maps.Marker({
                                map: vm.map,
                                position: {lat: p[1], lng: p[0]},
                            })
                        )
                    } else {
                        heatmapData.push(new google.maps.LatLng(p[1], p[0]));
                    }
				}
                if (!includeMarkers) {
                    vm.heatmap = new google.maps.visualization.HeatmapLayer({
                        data: heatmapData,
                    });
                    vm.heatmap.setMap(vm.map);
                }
			}
		}).finally(() => {
            vm.updatingLocations = false;
        });
	}

    function _buildPaths() {
        return vm.features.map((f) => {
				switch (f.type) {
					case FEAT_TYPES.FREEHAND:
						return f.data.getPath().getArray().map((p) => [p.lng(), p.lat()]);
					default:
						throw new Error(`Unexpected feature type ${f.type}`);
				}
			});
    }

	vm.sendMessage = function(message) {
		if (vm.features.length == 0) {
			return;
		}
		$http.post('/api/flux/notify/v2/create_notification/', {
			message: message,
			paths: _buildPaths(),
		}).then((response) => {
			vm.sent = true;
		});
	}

	vm.sendMessageV2 = function(message) {
		if (vm.features.length == 0) {
			return;
		}
		$http.post('/api/notify/v2/notifications', {
            data: {
                attributes: {
                    message_text: message,
                    paths: _buildPaths(),
                },
            }
		}).then((response) => {
			vm.sent = true;
		});
	}

	// vm.preparePolygon = function() {
	// 	vm.map.setOptions({
	// 		draggable: false,
	// 		draggableCursor: 'crosshair',
	// 	});
	// 	vm.drawingManager = new google.maps.drawing.DrawingManager({
	// 		drawingMode: google.maps.drawing.OverlayType.POLYGON,
	// 		drawingControl: false,
	// 		drawingControlOptions: {
	// 			position: google.maps.ControlPosition.TOP_RIGHT,
	// 			drawingModes: [google.maps.drawing.OverlayType.POLYGON]
	// 		},

	// 		polygonOptions: {
	// 			fillColor: '#0099FF',
	// 			fillOpacity: 0.7,
	// 			strokeColor: '#AA2143',
	// 			strokeWeight: 2,
	// 			clickable: true,
	// 			zIndex: 1,
	// 			editable: true
	// 		}
	// 	});

	// 	vm.drawingManager.setMap(vm.map);
	// }

	return vm;
});

export default MODULE_NAME;
